import { type Enum } from '@webapp/infrastructure/types/Enum'

export const LegalEntityListPageTabTypes = {
  ACTIVE: 'active',
  INACTIVE: 'inactive',
} as const

export type LegalEntityListPageTabType = Enum<
  typeof LegalEntityListPageTabTypes
>

export interface LegalEntityListPageParams {
  tab: LegalEntityListPageTabType
}
